import * as React from "react";
import Circle from "@mui/icons-material/Circle";

import { formatDate } from "../../../../utils/misc";

import { Button, TableRow, TableCell, Tooltip } from "@mui/material";

import LockResetIcon from "@mui/icons-material/LockReset";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import BlockIcon from "@mui/icons-material/Block";
import BoltIcon from "@mui/icons-material/Bolt";

import EditIcon from "@mui/icons-material/Edit";

function CharityRow({
  row,
  handleActionEdit,
  handleActionResetPassword,
  //handleActionForceLogoutAccount,
  handleOpenDisableConfirmation
}) {
  const fallbackImagePath = "/kiosk/getImage/CharityFallback";

  return (
    <TableRow key={row.locationCode}>
      <TableCell align="center">
        {row.enabled ? (
          <Circle style={{ color: "lightgreen" }} />
        ) : (
          <Circle style={{ color: "red" }} />
        )}
      </TableCell>
      <TableCell component="th" scope="row">
        {row.name}
      </TableCell>
      <TableCell align="left">
        {row.logoUrl && (
          <img
            src={row.logoUrl}
            // onLoad={() => setLoading(false)}
            style={{ maxHeight: "50px" }}
            alt={row.name + " Logo"}
            onError={e => {
              if (e.target.src !== fallbackImagePath) {
                e.target.src = fallbackImagePath;
              }
            }}
          />
        )}
        {!row.logoUrl && <div>No Logo Set</div>}
      </TableCell>
      <TableCell align="left">{row.pin}</TableCell>
      <TableCell align="left">{row.location.description}</TableCell>
      <TableCell align="left">
        <span style={{ textTransform: "capitalize" }}>{row.scope}</span>
      </TableCell>
      <TableCell align="left">{row.LastUpdatedBy}</TableCell>
      <TableCell align="left">
        {formatDate(row.updatedAt, "YYYY-MMM-DD HH:mm:ss")}
      </TableCell>

      {/* Actions */}
      <TableCell align="center">
        <div>
          {/* <Tooltip title={"Reset Password"} arrow placement="top">
            <Button
              variant="outlined"
              onClick={async () => {
                handleActionResetPassword(row._id);
              }}
            >
              <LockResetIcon id="fade-button" />
            </Button>
          </Tooltip> */}

          <Tooltip title={"Edit Charity"} arrow placement="top">
            <Button
              variant="outlined"
              onClick={async () => {
                handleActionEdit(row);
              }}
              style={{ marginLeft: "2px" }}
            >
              <EditIcon id="fade-button" />
            </Button>
          </Tooltip>
        </div>
      </TableCell>
    </TableRow>
  );
}

export default CharityRow;
